import axios from "../api";
/** The user's collected cards that count for the set, best item score first. */
export const getGalleryCollectedPlayers = async (setId) => {
    const res = await axios.get(`/gallery/collected/${setId}`);
    return res.data;
};
/** How many of the user's collected cards count for each active set. */
export const getGalleryCollectedCounts = async () => {
    const res = await axios.get("/gallery/collected/counts");
    return res.data;
};
export const setCollectedFirstOwner = async (resourceIds, firstOwner) => {
    await axios.put("/user-players/collected/first-owner", {
        resourceIds,
        firstOwner,
    });
};
/** Done tick on a Buy card: it counts as collected, without First Owner, from the next build on. */
export const addGalleryDoneTick = async (resourceId) => {
    await axios.put(`/user-players/collected/${resourceId}`);
};
/** Un-ticked Done tick: the card is no longer collected. */
export const removeGalleryDoneTick = async (resourceId) => {
    await axios.delete(`/user-players/collected/${resourceId}`);
};
//# sourceMappingURL=galleryCollectedPlayers.js.map